const constituentGroupMembershipConfig = {
  name: 'Constituent Group Membership',
  endpoint: '/internal_admin/admin_kit/constituent_group_memberships',
  modelKey: 'rbac_constituent_group_membership',

  columns: [
    { name: 'group_name', title: 'Parent Group', type: 'link' },
    { name: 'constituent_group_name', title: 'Constituent (Child) Group' },
    { name: 'created_by_name', title: 'Created By' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[group_name_cont]', label: 'Parent Group' },
    { name: 'q[constituent_group_name_cont]', label: 'Constituent Group' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'group_name', label: 'Parent Group' },
    { name: 'constituent_group_name', label: 'Constituent (Child) Group' },
    { name: 'created_by_name', label: 'Created By' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      {
        name: 'group_id',
        label: 'Parent Group',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/constituent_group_memberships/group_search',
        displayField: 'group_name',
        required: true,
      },
      {
        name: 'constituent_group_id',
        label: 'Constituent (Child) Group',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/constituent_group_memberships/group_search',
        displayField: 'constituent_group_name',
        required: true,
        helpMessage: 'Must belong to the same account as the parent group',
      },
    ],
  },
};

export default constituentGroupMembershipConfig;
